<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                :pages="[
                    {
                        name: $tc('messages.teachers', 2),
                        href: route('teachers.index'),
                    },
                    {
                        name: teacher.first_name,
                        href: route('teachers.show', teacher.id),
                    },
                    {
                        name: $tc('messages.subject', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="route('teacher.categories.update', teacher.id)" method="post" @submit.prevent="submit">
            <div v-for="stage in form.stages" class="mt-5" :key="stage.display_name">
                <h1 class="lg:text-lg font-medium text-gray-900">
                    {{ stage.display_name }}
                </h1>

                <div class="flex flex-col">
                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table class="min-w-full divide-y divide-gray-200">
                                    <thead>
                                        <tr>
                                            <th
                                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            >
                                                {{ $tc('messages.subject', 1) }}
                                            </th>
                                            <th
                                                v-for="group in stage.groups"
                                                :key="group.name"
                                                class="px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                            >
                                                {{ group.name }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-gray-200">
                                        <tr v-for="subject in stage.subjects" :key="subject.name">
                                            <td
                                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                            >
                                                {{ subject.name }}
                                            </td>
                                            <td
                                                v-for="group in stage.groups"
                                                :key="group.id"
                                                class="px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                            >
                                                <input
                                                    v-model="subject.group_ids"
                                                    :value="group.id"
                                                    type="checkbox"
                                                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                                                />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
    },
    props: ['teacher', 'stages', 'meta'],
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                stages: this.stages,
            }),
        };
    },
    name: 'Edit',
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
